import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="shared--password-toggle"
export default class extends Controller {
  connect() {
    this.addToggleIcons();
  }

  addToggleIcons() {
    const passwordFields = this.element.querySelectorAll(
      'input[type="password"]',
    );
    passwordFields.forEach((passwordField) => {
      // Skip if icon already exists (prevents duplicates)
      if (
        passwordField.nextElementSibling?.classList.contains("fa-eye") ||
        passwordField.nextElementSibling?.classList.contains("fa-eye-slash")
      ) {
        return;
      }

      // Add padding to the input to make room for the icon
      passwordField.style.paddingRight = "2.5rem";

      const icon = this.#createVisibilityIcon("fa-regular fa-eye");
      passwordField.insertAdjacentElement("afterend", icon);
    });
  }

  toggleVisibility(event) {
    // Find the icon element - it's the <i> element with fa-eye or fa-eye-slash
    const icon = event.currentTarget;
    const passwordField = icon.previousElementSibling;

    if (passwordField && passwordField.type === "password") {
      passwordField.type = "text";
      const newIcon = this.#createVisibilityIcon("fa-regular fa-eye-slash");
      icon.replaceWith(newIcon);
    } else if (passwordField) {
      passwordField.type = "password";
      const newIcon = this.#createVisibilityIcon("fa-regular fa-eye");
      icon.replaceWith(newIcon);
    }
  }

  #createVisibilityIcon(iconClasses) {
    const icon = document.createElement("i");
    icon.classList.add(
      ...iconClasses.split(" "),
      "absolute",
      "right-2",
      "top-2",
      "cursor-pointer",
    );
    icon.dataset.action = "click->shared--password-toggle#toggleVisibility";
    return icon;
  }
}
